import { HeyLightOrdersListScreen } from "../../Admin/HeyLight/HeyLightOrdersListScreen.tsx";

export const AllHeyLightOrdersCloserScreenPath = "/closer/heylight/all-orders";

export function AllHeyLightOrdersCloserScreen() {
  return <HeyLightOrdersListScreen readOnly />;
}
